import UIInterceptor from '@/UIInterceptors/UIInterceptor';
import ComponentManager from '@/Management/ComponentManager';
import {INavigationNodeDTO} from "coreframetypings/dto";

export default class ExpandUserNavigationTreeInterceptor extends UIInterceptor {

    constructor() {
        super();
    }
    
    public beforeLoadNavigationTree(navigationTree: INavigationNodeDTO) {
        this.expandFirstNodes(navigationTree, 20);
    }

    /**
     * Erweitert die ersten Knoten im Navigationsbaum bis zu einer bestimmten Anzahl von Knoten.
     *
     * @param {any} navigationTreeRoot - Die Wurzel des Navigationsbaums.
     * @param {number} limit - Die maximale Anzahl von Knoten, die erweitert werden sollen.
     * @returns {void}
     */
    private expandFirstNodes(navigationTreeRoot: INavigationNodeDTO, limit: number): void {
        this.traverseTree(navigationTreeRoot, node => {
            //Knoten überspringen, für die der Wert von isExpanded explizit auf false gesetzt wurde.
            if (node.isExpanded === false || node.childNodes == null) {
                return true;
            }
            
            limit = limit - node.childNodes.length;
            if (limit <= 0) {
                return false;
            }

            node.isExpanded = true;
            return true;
        });
    }
    
    /**
     * Traversiert einen Baum in Breitensuche und ruft eine Besucherfunktion für jeden Knoten auf.
     * Die Traversierung wird gestoppt, wenn die Abbruchbedingung erfüllt ist.
     * 
     * 1. Füge die Kinder der Wurzel zur Warteschlange hinzu.
     * 2. Solange die Warteschlange nicht leer ist:
     *      a. Entferne den ersten Knoten aus der Warteschlange.
     *      b. Überprüfe die Abbruchbedingung anhand des aktuellen Knotens.
     *          i. Falls die Abbruchbedingung erfüllt ist, beende die Traversierung.
     *      c. Verarbeite den aktuellen Knoten.
     *      d. Füge alle Kinder des aktuellen Knotens zur Warteschlange hinzu.
     * @param {any} root - Die Wurzel des Baums.
     * @param {(node: any) => boolean} visitor - Eine Funktion, die für jeden Knoten aufgerufen wird.
     *   - Die Funktion gibt `true` zurück, um die Traversierung fortzusetzen, oder `false`, um sie zu stoppen.
     * @returns {void}
     */
    private traverseTree(root: INavigationNodeDTO, visitor: (node: INavigationNodeDTO) => boolean): void {
        if (!root?.childNodes) {
           return; 
        }

        const queue: INavigationNodeDTO[] = [...root.childNodes];

        while (queue.length > 0) {
            const currentNode = queue.shift();

            if (!currentNode ) {
                continue;
            }
            
            if (!visitor(currentNode)) {
                return;
            }

            const children = currentNode.childNodes;
            if (children && children.length > 0) {
                queue.push(...children);
            }
        }
    }
}

ComponentManager.setUIInterceptor('ExpandUserNavigationTreeInterceptor', ExpandUserNavigationTreeInterceptor, 'RADPresentation.HTMLClient.DefaultViewExtensions');